import React, {useEffect, useRef, useState} from "react";
import styles from "./Contact.module.scss";
import {FaInstagram, FaFacebook, FaTiktok, FaEnvelope, FaPhone} from "react-icons/fa";
import {useForm} from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();
  const {register, handleSubmit, reset} = useForm();
  const [success, setScuccess] = useState(0);
  const [capVal, setCapVal] = useState(null);
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_qyn8wxo', 'template_o11zypd', form.current, {
        publicKey: 'H2B8U3BjzJu5czvGh',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          setScuccess(1);
        },
        (error) => {
          console.log('FAILED...', error.text);
          setScuccess(2);
        },
      );
  };

  return (
    <section id="kontakt" className={styles.contact} role="region" aria-label="Kontakt"> {/* Dodajemo role i aria-label */}
      <h2>Kontaktirajte nas</h2>
      <div className={styles.container}>
        <div className={styles.info}>
          <p><FaEnvelope/> escapeedancestudio@gmail.com</p>
          <p><FaPhone/> +381691114319</p>
          <div className={styles.socials}>
            <a href="https://www.instagram.com/plesna_skola_escape/" target="_blank"
               rel="noopener noreferrer"><FaInstagram/></a>
            <a href="https://www.facebook.com/people/Escape-Plesna-Skola/61571239581097/?sk=reels_tab" target="_blank" rel="noopener noreferrer"><FaFacebook/></a>
            <a href="https://www.tiktok.com/@plesnistudioescap" target="_blank" rel="noopener noreferrer"><FaTiktok/></a>
          </div>
          <div className={styles.map}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2830.108818936242!2d20.462564699999998!3d44.819347699999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a7ab47031d657%3A0xc70dc9aaf7919ea8!2sDobra%C4%8Dina%2030a%2C%20Beograd!5e0!3m2!1sen!2srs!4v1739034583029!5m2!1sen!2srs"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
        <form className={styles.form} ref={form} onSubmit={sendEmail}>
          <input {...register("name", {required: true})} type="text" name="from_name" placeholder="Vaše ime" required/>
          <input {...register("email", {required: true})} type="email" name="from_mail" placeholder="Vaš email" required/>
          <textarea {...register("message", {required: true})} name="message" placeholder="Vaša poruka" required></textarea>
          <ReCAPTCHA sitekey="6LfAaV8sAAAAAKq8CVSnYYifWD9e5wEdjwk3sViZ" onChange={val => setCapVal(val)}/>
          <input disabled={!capVal} id={styles.btn} type="submit" value="Pošalji"></input>
          {
            success === 1 ?
              <p id={styles.success}>Uspešno poslato!</p>
              : success === 2 ?
              <p id={styles.error}>Greška...</p>
              :
              <></>
          }
        </form>
      </div>
    </section>
  );
};

export default Contact;